import React, { useState } from 'react';
import { Button, Menu, MenuItem, Divider, ListSubheader } from '@mui/material';
import { useTranslation } from 'react-i18next';
import IconButton from '../../shared/icon_button';
import { useDispatch } from 'react-redux';
import { nextOnboardingStep, resetOnboarding, startOnboarding } from '../../../actions/onboarding';
import { useNavigate } from 'react-router-dom';

export const LoggedInDropdown = ({user, handleLogout}) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    dispatch(nextOnboardingStep());
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleResetTutorial = () => {
    handleClose();
    dispatch(resetOnboarding());
    dispatch(startOnboarding())
  }

  const handleNavigate = (route) => {
    handleClose();
    setTimeout(() => {
      dispatch(nextOnboardingStep());
    }, 1000); // small delay to let Menu unmount
    navigate(route, { replace: true });
    window.location.reload(); 
  }

  return (
    <div>
      <IconButton 
        icon='user'
        width={36}
        height={36}
        onClick={handleClick}
        extraStyling={'onboarding-step-1'}
        tooltip={t('userMenu.accountMenuTooltip')}
      >
        Login
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose} component="a" href={`/users/${user.id}`}>{t('userMenu.profile')}</MenuItem>
        <MenuItem onClick={handleClose} component="a" href={`/users/${user.id}/edit`}>{t('userMenu.accountSettings')}</MenuItem>
        {
          user.managedCustomers.length > 0 && (
            <>
              {/* <MenuItem onClick={handleResetTutorial}>Reseteaza Tutorial</MenuItem> */}
              <Divider className='primary' />
              <ListSubheader>{t('userMenu.myOrganisations')}</ListSubheader>
              { user.managedCustomers.map((customer) => (
                <MenuItem
                  key={customer.id} 
                  onClick={() =>handleNavigate(`/customers/${customer.id}`)}
                  className='onboarding-step-2'
                >
                  {customer.name}
                </MenuItem>
              ))}
            </>
          )
        }
        <Divider className='primary' />
        <MenuItem onClick={handleLogout} component="a" href="/">{t('userMenu.logout')}</MenuItem>
      </Menu>
    </div>
  );
};